import { Validators } from '@angular/forms';

export const itemsFormConfig = () => ({
	landingpages: [
		{
			type: 'input',
			key: 'title',
			templateOptions: {
				label: 'Event Name',
				required: true,
				appearance: 'fill',
			},
			validators: {
				validation: Validators.compose([Validators.required])
			}
		},
		{
			type: 'input',
			key: 'companyName',
			templateOptions: {
				label: 'Company',
				required: true,
				appearance: 'fill',
			}
		},
		{
			type: 'input',
			key: 'companyLogo',
			templateOptions: {
				label: 'Company Logo',
				required: true,
				appearance: 'fill',
			}
		},
		{
			type: 'input',
			key: 'eventLocation',
			templateOptions: {
				label: 'Location',
				required: true,
				appearance: 'fill',
			}
		},
		{
			type: 'textarea',
			key: 'locationDescription',
			templateOptions: {
				label: 'Location Description',
				rows: 5,
				description: 'Please enter at least 150 characters',
				appearance: 'fill',
			}
		},
		{
			key: 'date',
			type: 'date-time-picker',
			templateOptions: {
				label: 'Start date',
				appearance: 'fill',
			}
		},
		{
			key: 'description',
			type: 'textarea',
			templateOptions: {
				rows: 5,
				label: 'Body',
				description: 'Please enter at least 150 characters',
				required: true,
				appearance: 'fill',
			},
			validators: {
				validation: Validators.compose([Validators.required])
			}
		},
		{
			key: 'registerUrl',
			type: 'input',
			templateOptions: {
				label: 'Register URL',
				appearance: 'fill',
			}
		},
	],
	'system-menus': [
		{
			type: 'input',
			key: 'title',
			templateOptions: {
				label: 'Title',
				required: true
			},
			validators: {
				validation: Validators.compose([Validators.required])
			}
		},
		{
			type: 'input',
			key: 'icon',
			templateOptions: {
				label: 'Icon',
				required: true
			},
			validators: {
				validation: Validators.compose([Validators.required])
			}
		},
		{
			type: 'input',
			key: 'itemsType',
			templateOptions: {
				label: 'ItemsType',
				required: true
			},
			validators: {
				validation: Validators.compose([Validators.required])
			}
		},
		{
			type: 'numeric-input',
			key: 'order',
			templateOptions: {
				label: 'Order',
				required: true,
				mask: {
					allowDecimal: false
				}
			},
			validators: {
				validation: Validators.compose([Validators.required])
			}
		}
	]
});
